import React, { useEffect, useState } from 'react';
import useAsync from '../hooks/useAsync';
import UserServices from '../services/UserServices';
import Modal from 'react-modal';
import * as XLSX from 'xlsx';
import { useNavigate, useLocation } from 'react-router-dom';
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);
Modal.setAppElement('#root');

function VendorAttendance() {
  const [currentPage, setCurrentPage] = useState(1);
  const [AttendanceCount, setAttendanceCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const stateId = searchParams.get('id');
  const [data, setAttendanceData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentMonth, setCurrentMonth] = useState(currentDate.getMonth());
  const [currentYear, setCurrentYear] = useState(currentDate.getFullYear());
 


  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
    },
  };
  const datas = {
    labels: ["Present", "Absent", "Holiday"],
    datasets: [
      {
        data: [AttendanceCount.present, AttendanceCount.absent, AttendanceCount.holiday], 
        backgroundColor: ["#4b7f40", "#e63946", "#ffb703"],
        borderWidth: 1,
      },
    ],
  };
  
  useEffect(() => {
    if (stateId) {
      fetchCities();
    }
  }, [stateId, currentMonth, currentYear]); 
  

  const formatDateTime = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return "N/A";
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  };

  const usersPerPage = 20;
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;

  const calculateSalary = (attendance) => {
    const dailyRate = 100;
    return attendance * dailyRate;
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      const payload = { status: newStatus };
      await UserServices.updateVendorAttendanceStatus(id, payload);
      fetchCities();
    } catch (err) {
      console.error("Failed to update status:", err);
    }
  };

  const generateExcel = () => {
    const filteredData = data?.map((vendor) => ({
      date: formatDateTime(vendor?.date),
      name: vendor?.vendorId.name,
      mobileNo: vendor?.vendorId.mobileNo,
      status: vendor?.status,
    }));

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Vendor Salary');
    XLSX.writeFile(wb, 'vendor_salary_data.xlsx');
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };



  const updateClock = () => {
    const currentDateTime = new Date();
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const dayOfWeek = daysOfWeek[currentDateTime.getDay()];
    const englishDate = `${dayOfWeek} ${currentDateTime.getDate()} ${currentDateTime.toLocaleString('default', { month: 'long' })} ${currentYear}`;
    return englishDate;
  };

  const changeMonth = (direction) => {
    let newMonth = currentMonth + direction;
    let newYear = currentYear;

    if (newMonth < 0) {
      newMonth = 11;
      newYear--;
    } else if (newMonth > 11) {
      newMonth = 0;
      newYear++;
    }

    setCurrentMonth(newMonth);
    setCurrentYear(newYear);
  };


  // const renderCalendar = () => {
  //   const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  //   const firstDay = new Date(currentYear, currentMonth, 1).getDay();
  //   const calendarDays = [];
  // console.log("daysInMonth",daysInMonth)
  
  //   // Empty placeholders for first day offset
  //   for (let i = 0; i < firstDay; i++) {
  //     calendarDays.push(<div key={`empty-${i}`} className="empty-day"></div>);
  //   }
  
  //   // Render actual days
  //   for (let day = 1; day <= daysInMonth; day++) {
  //     const currentDay = `${currentYear}-${String(currentMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  //     const date = new Date(currentYear, currentMonth, day);
      
  //     const attendance = data.find(att => new Date(att.date).toLocaleDateString() === date.toLocaleDateString());
  //     const isHoliday = date.getDay() === 5 || date.getDay() === 6; // Friday-Saturday as holidays
  
  //     let statusSymbol = "";
  //     let statusClass = "";
  
  //     if (attendance?.status === "Present") {
  //       statusSymbol = "✔";
  //       statusClass = "present";
  //     } else if (attendance?.status === "Absent") {
  //       statusSymbol = <span className='closeicon'>✖</span>;
  //       statusClass = "absent";
  //     } else if (attendance?.status === "Holiday" ) {
  //       statusClass = "holiday";
  //     }
  
  //     calendarDays.push(
  //       <div
  //         key={`day-${day}`}
  //         className={`day ${statusClass}`}
  //         title={ (attendance ? `${attendance.reason}` : "")}
  //       >
  //         {day} {statusSymbol}
  //       </div>
  //     );
  //   }
  
  //   return calendarDays;
  // };


  
const renderCalendar = () => {
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const firstDay = new Date(currentYear, currentMonth, 1).getDay();
  const calendarDays = [];
  const now = new Date();
  
  const isPastMonth = currentYear < now.getFullYear() || 
                     (currentYear === now.getFullYear() && currentMonth < now.getMonth());
  const isCurrentMonth = currentYear === now.getFullYear() && currentMonth === now.getMonth();

  for (let i = 0; i < firstDay; i++) {
    calendarDays.push(<div key={`empty-${i}`} className="empty-day"></div>);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(currentYear, currentMonth, day);
    const isFutureDate = isCurrentMonth && day > now.getDate();
    
    const attendance = data.find(att => {
      const attDate = new Date(att.date);
      return (
        attDate.getDate() === day &&
        attDate.getMonth() === currentMonth &&
        attDate.getFullYear() === currentYear
      );
    });
    
    const isHoliday = date.getDay() === 5 || date.getDay() === 6; 

    let statusSymbol = "";
    let statusClass = "";
    if (isFutureDate) {
      statusSymbol = "";
      statusClass = "future";
    } 
    else if (isPastMonth || (isCurrentMonth && day <= now.getDate())) {
      statusSymbol = "✔";
      statusClass = "present";
    }
    if (attendance?.status === "Absent") {
      statusSymbol = <span className='closeicon'>✖</span>;
      statusClass = "absent";
    }
     else if ((attendance?.status === "Holiday" )) {
      statusClass = "holiday";
      statusSymbol = ""; 
    }

    calendarDays.push(
      <div
        key={`day-${day}`}
        className={`day ${statusClass}`}
        title={(attendance ? `${attendance.reason}` : "")}
      >
        {day} {statusSymbol}
      </div>
    );
  }

  return calendarDays;
};

  useEffect(() => {
  const now = new Date();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  let presentCount = 0;
  let absentCount = 0;
  let holidayCount = 0;

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(currentYear, currentMonth, day);
    const isPastMonth = currentYear < now.getFullYear() || 
                      (currentYear === now.getFullYear() && currentMonth < now.getMonth());
    const isCurrentMonth = currentYear === now.getFullYear() && currentMonth === now.getMonth();
    const isFutureDate = isCurrentMonth && day > now.getDate();

    const attendance = data.find(att => {
      const attDate = new Date(att.date);
      return (
        attDate.getDate() === day &&
        attDate.getMonth() === currentMonth &&
        attDate.getFullYear() === currentYear
      );
    });

    if (isFutureDate) {
   
      continue;
    }

    if ( attendance?.status === "Absent") {
      absentCount++;
    } else if (attendance?.status === "Holiday" ) {
      holidayCount++;
    } else if((isPastMonth || (isCurrentMonth && day <= now.getDate()))){
      presentCount++;
    }
  }

  setAttendanceCount({
    present: presentCount,
    absent: absentCount,
    holiday: holidayCount
  });
}, [currentYear, currentMonth, data]);
  
  const fetchCities = async () => {
    try {
      setIsLoading(true);
      const response = await UserServices.getAllVendorAttendance(stateId);
      
      const allData = response?.data || [];

      const filteredData = allData.filter(att => {
        const date = new Date(att.date);
        return date.getMonth() === currentMonth && date.getFullYear() === currentYear;
      });
      setAttendanceData(filteredData);
  
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };
  
  
  return (
    <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

<div className="my-auto">

  <h5 className="page-title fs-21 mb-1">  Vendor Attendance</h5>
  <nav>

    <ol className="breadcrumb mb-0">

      <li className="breadcrumb-item">
        <a href="javascript:void(0);">Home</a>
      </li>
      <li className="breadcrumb-item active" aria-current="page">
      Attendance
      </li>
    </ol>
  </nav>
</div>
<div className="d-flex my-xl-auto right-content align-items-center">

  <div className="pe-1 mb-xl-0">

    <div className="sub-title-box-right d-flex">
    <button className="excel-btn" onClick={generateExcel}>
            <img src="img/excel.svg" alt="Download Excel" />
            Download
          </button>
    </div>
  </div>



</div>
</div>
      
    
      <div className="container-box px-0 user-manager p-0">
        <div className="chart-container">
          <h3>Attendance Details</h3>
          <div className='d-flex justify-content-start align-items-center'>
            <div style={{ width: '300px' }}>
              <Doughnut data={datas} options={options} />
            </div>
            <div className='card attendace_card mx-auto'>
              <ul>
                <li style={{ color: "#4b7f40" }}><strong>{AttendanceCount.present}</strong> Present</li>
                <li style={{ color: "#e63946" }}><strong>{AttendanceCount.absent}</strong> Absent</li>
                <li style={{ color: "#ffb703" }}><strong>{AttendanceCount.holiday}</strong> HoliDay</li>
              </ul>
            </div>
          </div>
        </div>
      </div>


      <div className="App">
        <div className="calendar-container">
          <div className="calendar-header">
            <button id="prev-month" onClick={() => changeMonth(-1)}>Previous</button>
            <h2 id="calendar-month">
              {new Date(currentYear, currentMonth).toLocaleString('default', { month: 'long' })} {currentYear}
            </h2>
            <button id="next-month" onClick={() => changeMonth(1)}>Next</button>
          </div>
          <div id="calendar">{renderCalendar()}</div>
        </div>
      </div>
    </div>
  );
}

export default VendorAttendance;